import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "components/SchoolReportHeader";
import { Select } from "antd";
import { states } from "./states";
import "./index.scss";

const { Option } = Select;

const apiURL = "https://fluency.getfreadom.com/cmfluency/freadom_airr";

function AIRRReport() {
  const [rankList, setRankList] = useState([]);
  const [selectedState, setSelectedState] = useState("0");
  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    setStateList(states.sort());
  }, []);

  const getRankListing = async () => {
    const params =
      selectedState !== "0"
        ? {
            state: selectedState,
          }
        : {};

    await axios
      .get(apiURL, {
        params,
      })
      .then((res) => {
        console.log("res", res);
        if (res.data.Status === "Success") {
          setRankList(res.data.data);
        }
      });
  };

  useEffect(() => {
    getRankListing();
  }, [selectedState]);

  return (
    <>
      <Header isLogin />

      <div className="school-report-container ">
        <div className="container">
          <h1>All India Reading Rank</h1>
          <div className="report_pre_title">
            {selectedState !== "0"
              ? `Top 10 schools who have read the most across ${selectedState}`
              : "Top 10 schools who have read the most across the country."}
          </div>
          <div className="bg-white">
            <div className="select-wrapper">
              <span>Select State: &nbsp;&nbsp;</span>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                defaultValue={selectedState}
                style={{ width: 250 }}
                onChange={setSelectedState}
              >
                <Option value="0">--ALL--</Option>
                {stateList.map((state, index) => (
                  <Option key={index} value={state}>
                    {state}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="table-border">
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>School Name</th>
                    <th>State</th>
                  </tr>
                </thead>
                <tbody>
                  {rankList.map((rank, index) => (
                    <tr key={index}>
                      <td>{rank.rank}</td>
                      <td>{rank.school_name}</td>
                      <td>{rank.state}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AIRRReport;
